<div class="message">
  @if (providerIconName) {
    <div class="message-icons">
      @if (logo) {
        <ly-icon class="message-icon" [icon]="logo" size="48px" alt="" />
        <ly-icon
          class="message-icon-connection"
          icon="leftRightArrow"
          size="32px"
          alt=""
        />
      }
      <ly-icon
        class="message-icon {{ providerIconName }}"
        [icon]="providerIconName"
        size="36px"
        alt=""
      />
    </div>
  }
  @if (title) {
    <h2 class="message-header">{{ title }}</h2>
  }
  @if (description) {
    <p class="message-description">{{ description }}</p>
  }
  <div class="message-actions">
    <ng-content></ng-content>
  </div>
</div>
